import { Controller } from "stimulus"

# Controller for the hosted registration capacity modification form.
#
# When typing in either the "add" or "remove" field, the other field is cleared.
# This ensures only one operation can be submitted at a time.
#
# Expected HAML markup:
#
#   = form_with ..., data: { controller: 'event--capacity-form' } do |f|
#     = f.text_field :add_quantity, data: { action: 'input->event--capacity-form#clearOther', event__capacity_form_target: 'addField' }
#     = f.text_field :remove_quantity, data: { action: 'input->event--capacity-form#clearOther', event__capacity_form_target: 'removeField' }
#
export default class extends Controller
  @targets: ["addField", "removeField"]

  clearOther: (event) ->
    if event.target is @addFieldTarget
      @removeFieldTarget.value = ""
    else if event.target is @removeFieldTarget
      @addFieldTarget.value = ""
